import { Translation } from './types';

export const de: Translation = {
  common: {
    loading: 'Lädt...',
    error: 'Fehler',
    cancel: 'Abbrechen',
    save: 'Speichern',
    close: 'Schließen',
    search: 'Suchen',
    reload: 'Neu laden',
    logout: 'Abmelden',
    dashboard: 'Dashboard',
    products: 'Produkte',
    settings: 'Einstellungen',
    language: 'Sprache',
    businessHours: 'Geschäftszeiten',
    back: 'Zurück',
    selectAll: 'Alle auswählen',
    deselectAll: 'Auswahl aufheben',
    success: 'Erfolg',
    selected: 'Ausgewählt',
    confirm: 'Bestätigen',
    required: 'Erforderlich',
    requiredMarker: '*',
    previous: 'Zurück',
    next: 'Weiter',
    allRightsReserved: 'Alle Rechte vorbehalten.',
  },
  auth: {
    login: 'Anmelden',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    loginButton: 'Anmelden',
    loggingIn: 'Wird angemeldet...',
    loginSuccess: 'Erfolgreich angemeldet',
    loginError: 'E-Mail oder Passwort ist falsch',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    requiredFields: 'Bitte geben Sie E-Mail und Passwort ein',
    demoAccount: 'Demo-Konto:',
    loginDescription: 'Geben Sie Ihre Kontodaten ein, um sich anzumelden',
    welcomeMessage: 'Willkommen im Geschäftsbestellsystem',
    // Registration
    register: 'Registrieren',
    createAccount: 'Konto erstellen',
    confirmPassword: 'Passwort bestätigen',
    passwordRequirements: 'Passwort muss mindestens 8 Zeichen lang sein und Groß-, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    registrationSuccess: 'Registrierung erfolgreich',
    registrationDescription: 'Registrieren Sie sich für ein Geschäftskonto',
    alreadyHaveAccount: 'Bereits ein Konto vorhanden?',
    signIn: 'Anmelden',
    dontHaveAccount: 'Noch kein Konto?',
    creatingAccount: 'Konto wird erstellt...',
    registrationNote: 'Hinweis:',
    registrationNotePoints: {
      erpLinking: 'Wenn Sie bereits ein Geschäftskonto haben, wird Ihre E-Mail automatisch verknüpft',
      companyEmail: 'Bitte verwenden Sie Ihre Unternehmens-E-Mail-Adresse für die Registrierung',
      contactSupport: 'Kontaktieren Sie den Support, wenn Sie Hilfe bei der Registrierung benötigen'
    },
    b2bUsers: 'Geschäftskonto-Benutzer:',
    registeredEmail: 'Registrierte E-Mail-Adresse',
    registeredPassword: 'Bei der Registrierung festgelegtes Passwort',
    b2bCustomerRequired: 'Diese E-Mail-Adresse ist nicht als Geschäftskunde registriert. Bitte wenden Sie sich an den Vertrieb, um zunächst eine Geschäftsbeziehung zu etablieren.',
    b2bVerificationError: 'Geschäftskundenstatus konnte nicht überprüft werden. Bitte wenden Sie sich an den Support.',
    // Password Reset
    passwordReset: 'Passwort zurücksetzen',
    passwordResetDescription: 'E-Mail-Adresse eingeben, um ein temporäres Passwort zu erhalten',
    getTemporaryPassword: 'Temporäres Passwort erhalten',
    processing: 'Verarbeitung...',
    passwordResetComplete: 'Passwort-Reset abgeschlossen',
    temporaryPasswordGenerated: 'Temporäres Passwort wurde generiert',
    temporaryPassword: 'Temporäres Passwort',
    backToLogin: 'Zurück zur Anmeldung',
    securityNotice: 'Sicherheitshinweis:',
    securityNotePoints: {
      keepSecret: 'Geben Sie das temporäre Passwort nicht an andere weiter',
      changeAfterLogin: 'Ändern Sie nach der Anmeldung unbedingt Ihr Passwort',
      expires24Hours: 'Das temporäre Passwort läuft nach 24 Stunden ab'
    },
    resetNote: 'Hinweis:',
    resetNotePoints: {
      registeredEmail: 'Geben Sie Ihre registrierte E-Mail-Adresse ein',
      passwordDisplayed: 'Das temporäre Passwort wird auf dem Bildschirm angezeigt',
      changeRequired: 'Nach der Anmeldung ist eine Passwort-Änderung erforderlich'
    },
    copied: 'Kopiert',
    copySuccessMessage: 'Temporäres Passwort wurde in die Zwischenablage kopiert.',
    forgotPassword: 'Passwort vergessen?',
    // Password Reset Email Request
    sendResetLink: 'Reset-Link senden',
    sendingEmail: 'E-Mail wird gesendet...',
    emailSent: 'E-Mail gesendet',
    emailSentMessage: 'Falls diese E-Mail-Adresse in unserem System existiert, erhalten Sie in Kürze einen Passwort-Reset-Link.',
    emailNotSent: 'E-Mail nicht gesendet',
    emailSentInfo: 'Prüfen Sie Ihr E-Mail-Postfach und Ihren Spam-Ordner',
    checkEmail: 'E-Mail prüfen',
    emailInstructions: 'Anweisungen zum Passwort-Reset wurden gesendet',
    nextSteps: 'Nächste Schritte:',
    nextStepsList: {
      checkInbox: 'Prüfen Sie Ihr E-Mail-Postfach und Spam-Ordner',
      clickLink: 'Klicken Sie auf den Reset-Link in der E-Mail',
      linkExpires: 'Der Link läuft in 24 Stunden ab',
      contactSupport: 'Kontaktieren Sie den Support, falls Sie keine E-Mail erhalten',
      rateLimitInfo: 'Begrenzt auf 3 Anfragen pro Stunde'
    },
    // Password Reset Completion
    resetLinkSent: 'Reset-Link gesendet',
    resetSuccess: 'Passwort erfolgreich zurückgesetzt',
    passwordUpdated: 'Passwort aktualisiert',
    passwordUpdateMessage: 'Ihr Passwort wurde erfolgreich aktualisiert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
    loginWithNewPassword: 'Mit neuem Passwort anmelden',
    // Reset Token Page
    resetToken: 'Passwort zurücksetzen',
    invalidToken: 'Ungültiger Reset-Token',
    expiredToken: 'Reset-Token ist abgelaufen',
    tokenValid: 'Reset-Token ist gültig',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    updatePassword: 'Passwort aktualisieren',
    updatingPassword: 'Passwort wird aktualisiert...',
    passwordMismatch: 'Passwörter stimmen nicht überein',
    resetInstructions: 'Geben Sie Ihr neues Passwort ein, um den Reset abzuschließen',
  },
  accountInfo: {
    title: 'Kontoinformationen',
    loading: 'Kontoinformationen werden geladen...',
    error: 'Fehler',
    errorMessage: 'Kontoinformationen konnten nicht abgerufen werden',
    back: 'Zurück',
    basicInfo: 'Grundinformationen',
    name: 'Name',
    email: 'E-Mail-Adresse',
    contactId: 'Knitido-Kunden-ID',
    contactNumber: 'Kontaktnummer',
    noInfo: 'Keine Informationen',
    companyInfo: 'Unternehmensinformationen',
    company: 'Unternehmensname',
    position: 'Position',
    vatId: 'USt-IdNr.',
    billingAddress: 'Rechnungsadresse',
    deliveryAddress: 'Lieferadresse',
    addressInfo: 'Adressinformationen',
    billingDescription: 'Adresse für Rechnungen und Vertragsdokumente',
    deliveryDescription: 'Standard-Lieferadresse für Produktlieferungen',
    sameAsBilling: '※ Identisch mit Rechnungsadresse',
    sameAsDelivery: '※ Identisch mit Lieferadresse',
    companyName: 'Unternehmensname',
    contactPerson: 'Ansprechpartner',
    address: 'Adresse',
    phoneNumber: 'Telefonnummer',
    billingUsage: 'Wird als Ziel für Rechnungen, Verträge und andere wichtige Dokumente verwendet',
    deliveryUsage: 'Wird als Standard-Lieferadresse für bestellte Produkte verwendet',
    alsoUsedForDelivery: 'Wird auch als Lieferziel verwendet',
    accountType: 'Kontotyp',
    addressId: 'Adresse-ID',
    // Address editing functionality
    edit: 'Bearbeiten',
    editDeliveryAddress: 'Lieferadresse bearbeiten',
    editDeliveryDescription: 'Aktualisieren Sie Ihre Lieferadresse',
    newDeliveryAddress: 'Neue Lieferadresse hinzufügen',
    newDeliveryDescription: 'Geben Sie die Details für Ihre neue Lieferadresse ein',
    noDeliveryAddress: 'Keine Lieferadresse konfiguriert',
    success: 'Erfolgreich',
    addressUpdated: 'Lieferadresse erfolgreich aktualisiert',
    updateError: 'Fehler beim Aktualisieren der Lieferadresse',
    requiredFields: 'Bitte füllen Sie alle Pflichtfelder aus',
    firstName: 'Vorname',
    lastName: 'Nachname',
    streetAddress: 'Straßenadresse',
    streetAddress2: 'Straßenadresse 2',
    city: 'Stadt',
    country: 'Land',
    selectCountry: 'Land auswählen...',
    searchCountry: 'Land suchen...',
    noCountryFound: 'Kein Land gefunden.',
    postalCode: 'Postleitzahl',
    companyNamePlaceholder: 'Firmenname eingeben',
    firstNamePlaceholder: 'Vorname',
    lastNamePlaceholder: 'Nachname',
    streetAddressPlaceholder: 'Straßenadresse eingeben',
    streetAddress2Placeholder: 'Wohnung, Suite, etc.',
    cityPlaceholder: 'Stadt eingeben',
    postalCodePlaceholder: 'Postleitzahl eingeben',
    billingNotEditable: 'Die Rechnungsadresse kann nicht bearbeitet werden.',
    billingContactSupport: 'Kontaktieren Sie den Support für Änderungen.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} Lieferadressen',
    noDeliveryAddresses: 'Keine Lieferadressen registriert',
    defaultAddress: 'Standard',
    selectDeliveryAddress: 'Lieferadresse auswählen',
    addNewAddress: 'Neue Adresse hinzufügen',
    editAddress: 'Adresse bearbeiten',
    deleteAddress: 'Adresse löschen',
    confirmDelete: 'Löschen bestätigen',
    confirmDeleteMessage: 'Möchten Sie diese Adresse wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
    addressAddedSuccess: 'Lieferadresse hinzugefügt',
    addressDeletedSuccess: 'Lieferadresse gelöscht',
    deleteError: 'Fehler beim Löschen der Lieferadresse',
    saving: 'Speichern...',
    cancel: 'Abbrechen',
    saveChanges: 'Änderungen speichern',
    selectedDeliveryAddress: 'Ausgewählte Lieferadresse',
  },
  dashboard: {
    title: 'Business Partner',
    subtitle: 'Produkt-Bestellsystem',
    welcome: 'Willkommen,',
    welcomeMessage: 'Willkommen im Business Partner Bestellsystem. Hier können Sie Produkte bestellen.',
    productCatalog: 'Produktkatalog',
    productCatalogDesc: 'Verfügbare Produkte durchsuchen und bestellen',
    viewProducts: 'Produkte ansehen',
    orderHistory: 'Bestellhistorie',
    orderHistoryDesc: 'Vergangene Bestellungen einsehen (in Vorbereitung)',
    accountSettings: 'Kontoeinstellungen',
    accountSettingsDesc: 'Kontoinformationen verwalten (in Vorbereitung)',
    comingSoon: 'In Vorbereitung',
    infoTitle: 'Über die Nutzung',
    orderingInfo: 'Produktbestellung',
    orderingDesc: 'Wählen Sie aus dem Produktkatalog die gewünschten Artikel aus und geben Sie Größe und Farbe an. Lagerbestände werden in Echtzeit angezeigt.',
    supportInfo: 'Support',
    supportDesc: 'Bei Fragen wenden Sie sich gerne an uns.',
    viewOrderHistory: 'Bestellhistorie anzeigen',
    viewOrders: 'Bestellungen anzeigen',
    accountInfo: 'Kontoinformationen',
    accountInfoDesc: 'Ihre Kontodaten einsehen',
    viewDetails: 'Details anzeigen',
    supportEmail: 'b2b-partner@knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Montag-Freitag 9:00-15:00 Uhr',
    bulkImportDesc: 'Bestellungen aus Excel/CSV-Dateien importieren',
    importOrders: 'Bestellungen importieren',
  },
  products: {
    title: 'Produktliste',
    subtitle: 'Business Partner',
    searchPlaceholder: 'Nach Produktname oder SKU suchen...',
    productId: 'Produkt-ID',
    addToCart: 'In den Warenkorb',
    selectVariation: 'Variante auswählen',
    price: 'Preis',
    priceNetNotice: 'Alle Preise sind Nettopreise',
    stock: 'Lagerbestand',
    color: 'Farbe',
    newProducts: 'Neu-Produkte',
    newProductBadge: 'NEU',
    size: 'Größe',
    quantity: 'Menge',
    total: 'Gesamt',
    cart: 'Warenkorb',
    checkout: 'Zur Kasse',
    csvMode: 'CSV-Schnellmodus',
    csvInfo: 'Produktdaten aus CSV-Daten abgerufen',
    csvUploadDate: 'CSV-Upload-Datum:',
    stockNote: '※ Lagerinformationen werden bei der Produktvariantenauswahl abgerufen',
    noProducts: 'Keine Produkte gefunden',
    noProductsDesc: 'Ändern Sie die Suchkriterien oder laden Sie eine CSV-Datei für bessere Performance hoch.',
    retry: 'Erneut versuchen',
    pagination: 'Artikel',
    variations: 'Varianten',
    stockFetchError: 'Lagerbestandsfehler',
    stockFetchFailed: 'Lagerbestand-Abruf fehlgeschlagen',
    stockFetchFailedDesc: 'Lagerbestand konnte nicht abgerufen werden. CSV-Bestand wird angezeigt.',
    stockFetched: 'Lagerbestand abgerufen',
    totalStock: 'Gesamtbestand',
    noStockAll: 'Alle Varianten haben null Bestand',
    noStockData: 'Keine Bestandsdaten erhalten',
    stockFetchErrorDesc: 'Fehler beim Abrufen der Bestandsdaten',
    selectionError: 'Auswahlfehler',
    enterQuantity: 'Bitte Menge eingeben',
    addedToCart: 'Zum Warenkorb hinzugefügt',
    typesAdded: ' Produkttypen hinzugefügt',
    addToCartError: 'Fehler beim Hinzufügen zum Warenkorb',
    addToCartErrorDesc: 'Bitte versuchen Sie es erneut',
    loadingStock: 'Lade Lagerbestand',
    csvDataInfo: 'CSV-Daten werden angezeigt (nicht die tatsächlichen Lagerbestände)',
    invalidDataFormat: 'Produktdatenformat ist ungültig',
    loadFailed: 'Fehler beim Laden der Produktdaten',
    csvUploadComplete: 'CSV-Upload abgeschlossen',
    csvLoadedDesc: ' Produktdaten geladen. Lagerinformationen werden bei der Produktauswahl abgerufen.',
    searchTitle: 'Produktsuche',
    loadingProducts: 'Lade Produktdaten',
    noProductsCsv: 'Keine Produkte in CSV-Daten gefunden. Bitte ändern Sie die Suchkriterien.',
    paginationDisplay: ' werden angezeigt',
    previous: 'Zurück',
    next: 'Weiter',
    selectionSummary: 'Auswahlzusammenfassung',
    selectedQuantity: 'Ausgewählte Menge',
    items: ' Stück',
    viewDetails: 'Details anzeigen',
    productImage: 'Produktbild',
    correspondingVariations: 'Entsprechende Varianten',
    clickToEnlarge: 'Klicken zum Vergrößern',
    productIdLabel: 'Produkt-ID',
    colorLabel: 'Farbe',
    filterByCategory: 'Nach Kategorie filtern',
    allProducts: 'Alle Produkte',
    applyFilters: 'Filter anwenden',
    clearFilters: 'Filter löschen',
    filters: 'Filter',
    clearAll: 'Alle löschen',
  },
  categories: {
    category_21: 'Zehensocken',
    category_23: 'Unkategorisiert',
    category_24: 'Torso',
    category_29: 'B2B-Produkt',
  },
  productDetail: {
    title: 'Produktdetails',
    backToProducts: 'Zurück zur Produktliste',
    productNotFound: 'Produkt nicht gefunden',
    productNotFoundDesc: 'Das angegebene Produkt existiert nicht oder wurde gelöscht.',
    loading: 'Produkt wird geladen...',
    imageLoadError: 'Fehler beim Laden der Bilder',
    noImages: 'Keine Bilder verfügbar',
    productDescription: 'Produktbeschreibung',
    colors: 'Farben',
    sizes: 'Größen',
    colorCount: 'Farben',
    sizeCount: 'Größen',
    variationCount: 'Varianten',
    selectVariation: 'Varianten auswählen',
    descriptionLanguageNote: '※ Produktbeschreibungen sind nur auf Englisch oder Deutsch verfügbar',
  },
  colors: {
    schwarz: 'Schwarz',
    weiß: 'Weiß',
    grau: 'Grau',
    rot: 'Rot',
    blau: 'Blau',
    grün: 'Grün',
    gelb: 'Gelb',
    rosa: 'Rosa',
    lila: 'Lila',
    braun: 'Braun',
    orange: 'Orange',
    beige: 'Beige',
    navy: 'Navy',
    dunkelblau: 'Dunkelblau',
    hellblau: 'Hellblau',
    dunkelgrau: 'Dunkelgrau',
    hellgrau: 'Hellgrau',
    bordeaux: 'Bordeaux',
    türkis: 'Türkis',
    khaki: 'Khaki',
    mint: 'Mint',
    violett: 'Violett',
    anthrazit: 'Anthrazit',
    blaugrau: 'Blaugrau',
    burgunderrot: 'Burgunderrot',
    elfenbein: 'Elfenbein',
    karminrot: 'Karminrot',
    neongrün: 'Neongrün',
    gelbgrün: 'Gelbgrün',
    pistazie: 'Pistazie',
    // Englische Farbnamen (verwendet in Product ID 237 usw.)
    blue: 'Blau',
    ivory: 'Elfenbein',
    green: 'Grün',
    gold: 'Gold',
    red: 'Rot',
  },
  checkout: {
    title: 'Bestellung aufgeben',
    cartReview: 'Bestellungsüberprüfung',
    orderSummary: 'Bestellzusammenfassung',
    shippingInfo: 'Versandinformationen',
    billingInfo: 'Rechnungsinformationen',
    orderNotes: 'Bestellnotizen',
    orderNotesPlaceholder: 'Besondere Wünsche oder Anmerkungen...',
    contactPerson: 'Ansprechpartner',
    phoneNumber: 'Telefonnummer',
    email: 'E-Mail-Adresse',
    company: 'Unternehmen',
    address: 'Adresse',
    city: 'Stadt',
    postalCode: 'Postleitzahl',
    country: 'Land',
    deliveryDate: 'Liefertermin',
    urgentDelivery: 'Eillieferung (3-5 Werktage)',
    standardDelivery: 'Standardlieferung (7-10 Werktage)',
    placeOrder: 'Bestellung aufgeben',
    backToCart: 'Zurück zur Produktauswahl',
    requiredField: 'Pflichtfeld',
    orderTotal: 'Gesamtbetrag',
    subtotal: 'Zwischensumme',
    priceNetNotice: 'Alle Preise sind Nettopreise',
    stockReservationNotice: 'Die Reservierung der Artikel erfolgt erst nach Bestätigung Ihrer Bestellung.',
    stockCheckError: 'Lagerbestand-Prüfungsfehler',
    stockCheckErrorDesc: 'Fehler bei der Lagerbestandsprüfung. Bitte versuchen Sie es erneut.',
    shipping: 'Versand',
    shippingCost: 'Versandkosten',
    tax: 'MwSt.',
    orderSuccess: 'Bestellung erfolgreich',
    orderSuccessMessage: 'Ihre Bestellung wurde erfolgreich übermittelt. Bestellnummer: {orderNumber}',
    orderNumber: 'Bestellnummer',
    thankYou: 'Vielen Dank für Ihre Bestellung!',
    orderConfirmation: 'Ihre Bestellung wurde erfolgreich übermittelt.',
    orderProcessing: 'Nach Prüfung durch unser Team senden wir Ihnen die Auftragsbestätigung per E-Mail zu.',
    orderProcessingMessage: 'Ihre Bestellung wurde erfolgreich übermittelt. Nach Prüfung durch unser Team senden wir Ihnen die Auftragsbestätigung per E-Mail zu.',
    continueShopping: 'Weiter einkaufen',
    emptyCart: 'Ihr Warenkorb ist leer',
    emptyCartMessage: 'Bitte fügen Sie Produkte zum Warenkorb hinzu, um fortzufahren',
    stockWarning: 'Lagerbestand-Warnung',
    stockWarningDesc: 'Einige Artikel haben unzureichenden Lagerbestand. Bitte passen Sie die Mengen an.',
    stockError: 'Lagerbestand-Fehler',
    stockErrorDesc: 'Es gibt Artikel mit unzureichendem Lagerbestand. Bitte passen Sie die Mengen an.',
    refreshStock: 'Lagerbestand aktualisieren',
    stockUpdated: 'Lagerbestand aktualisiert',
    stockUpdatedDesc: 'Lagerbestand wurde aktualisiert - {changed} Artikel geändert',
    stockCheckDesc: 'Vergleichsergebnisse mit Lagerbestand werden angezeigt',
    stockOk: 'Lager OK',
    stockShortage: 'Lagermangel',
    requestedQty: 'Gewünschte Menge',
    currentStock: 'Aktueller Lagerbestand',
    stockShortageMsg: 'Nicht genügend Lagerbestand. Bitte passen Sie die Menge an.',
    stockIssueWarning: 'Die Bestellung kann aufgrund von Lagerbestandsproblemen nicht bestätigt werden.',
    stockDataMissing: 'Lagerbestandsdaten werden abgerufen. Bitte warten Sie einen Moment.',
    outOfStock: 'Ausverkauft.',
    maxAvailable: 'Maximum',
    maxQuantityReached: 'Maximale Lagermenge erreicht.',
    autoRestored: 'Warenkorb wiederhergestellt',
    autoRestoredDesc: 'Artikel aus Ihrer letzten Sitzung wurden wiederhergestellt',
    // ERP Contact Search
    contactSearch: 'Kundenkontakt-Suche',
    contactSearchDesc: 'Geben Sie die E-Mail-Adresse des Bestellers ein, um Kontaktinformationen abzurufen',
    emailAddress: 'E-Mail-Adresse',
    searchButton: 'Suchen',
    searching: 'Suche läuft',
    contactFound: 'Kontakt gefunden',
    contactNotFound: 'Kontakt nicht gefunden',
    contactId: 'Knitido-Kunden-ID',
    companyName: 'Unternehmen',
    contactPersonLabel: 'Ansprechpartner',
    addressesFound: 'Adressen gefunden',
    addressType: 'Typ',
    addressBilling: 'Rechnungsadresse',
    addressDelivery: 'Lieferadresse',
    vatSourceCompany: 'Firmendaten',
    vatSourceBilling: 'Rechnung',
    vatSourceDelivery: 'Lieferung',
    addressOther: 'Andere',
    addressDetails: 'Adresse',
    loadingAddresses: 'Adressinformationen werden geladen...',
    addressRetrieved: 'Adressinformationen abgerufen',
    addressNotFound: 'Adressinformationen nicht gefunden',
    addressNotFoundDesc: 'Keine Adressinformationen registriert. Bitte manuell eingeben.',
    addressError: 'Adressabruf-Fehler',
    addressErrorDesc: 'Adressinformationen konnten nicht abgerufen werden.',
    contactNotConfirmed: 'Kundenkontakt nicht bestätigt',
    contactNotConfirmedDesc: 'Bitte geben Sie eine E-Mail-Adresse ein und suchen Sie nach dem Kontakt.',
    searchContact: 'Kontakt suchen',
    inputError: 'Eingabefehler',
    inputErrorDesc: 'Versandinformationen sind fehlerhaft. Bitte überprüfen Sie.',
    processing: 'Verarbeitung läuft...',
    erpContactSearch: 'Kundenkontakt-Suche',
    contactSearchError: 'Die E-Mail-Adresse entspricht keinem registrierten Kontakt.',
    // Product Images Toggle
    showProductImages: 'Produktbilder anzeigen',
    showProductImagesDesc: 'Produktbilder für bessere Übersicht anzeigen (kann die Ladezeit erhöhen)',
    // System Registration Info
    systemRegistrationInfo: 'Ihre Kundeninformationen',
    systemRegistrationInfoDesc: 'Ihre hinterlegten Geschäftsinformationen. Bei Änderungswünschen der Rechnungsadresse kontaktieren Sie bitte Ihren Ansprechpartner.',
    editShippingAddress: 'Lieferadresse bearbeiten',
    // Order Summary
    regularPrice: 'Regulärer Großhandelspreis',
    offeredPrice: 'Angebotspreis',
    discount: 'Rabatt',
    b2bCustomer: 'B2B-Kunde',
    pattern: 'Muster',
    specialPriceApplied: 'Sonderpreis angewendet',
    customerClassification: 'Kundenklassifizierung',
    paymentCondition: 'Zahlungsbedingungen',
    invoice: 'Rechnung (NET 30)',
    prepayment: 'Vorauszahlung',
    paymentMethod: 'Zahlungsweise',
    invoicePayment: 'Zahlung auf Rechnung',
    estimatedSubtotal: 'Geschätzte Zwischensumme',
    estimatedTotal: 'Geschätzter Gesamtbetrag',
    orderSummaryDisclaimer: 'Die hier angezeigten Preise sind Richtwerte. Nach Eingang Ihrer Bestellung prüfen wir diese und senden Ihnen eine verbindliche Auftragsbestätigung mit den finalen Preisen, Versandkosten und Steuern per E-Mail zu.',
    searchError: 'Suchfehler',
    searchErrorDesc: 'Ein Fehler ist während der Kontaktsuche aufgetreten.',
    confirmDeleteItem: 'Artikel entfernen',
    itemDeleted: 'Artikel entfernt',
    confirmDeleteItemDesc: 'Möchten Sie den folgenden Artikel aus dem Warenkorb entfernen?',
    deleteConfirm: 'Entfernen',
    contactNotes: 'Mitteilungen',
    contactNotesDesc: 'Haben Sie Fragen oder besondere Wünsche? Teilen Sie uns diese gerne mit (optional)',
    contactNotesLabel: 'Nachricht',
    contactNotesPlaceholder: 'z.B.: Fragen zu Produkten, besondere Anforderungen usw.',
    characters: 'Zeichen',
    contactIdLabel: 'Knitido-Kunden-ID',
    companyLabel: 'Unternehmen',
    personLabel: 'Ansprechpartner',
    emailLabel: 'E-Mail',
    addressTypeLabel: 'Typ',
    destinationLabel: 'Ziel',
    // Shipping Form
    shippingTitle: 'Versandinformationen',
    shippingDesc: 'Geben Sie die Lieferadresse für die Produkte ein',
    companyRequired: 'Unternehmen *',
    contactPersonRequired: 'Ansprechpartner *',
    emailRequired: 'E-Mail-Adresse *',
    phoneRequired: 'Telefonnummer *',
    addressRequired: 'Adresse 1 *',
    address2: 'Adresse 2 (Gebäudename/Zimmernummer)',
    postalCodeRequired: 'Postleitzahl *',
    cityRequired: 'Stadt *',
    countryRequired: 'Land *',
    selectCountry: 'Land auswählen',
    shippingMethodRequired: 'Versandart *',
    selectShippingMethod: 'Versandart auswählen',
    urgentDeliveryOption: 'Expressversand (zusätzliche Gebühren)',
    deliveryNotes: 'Anmerkungen zur Lieferung',
    deliveryNotesPlaceholder: 'Lieferzeiten oder andere Wünsche hier eingeben',
    standardShipping: 'Standardversand (3-5 Werktage)',
    expressShipping: 'Expressversand (1-2 Werktage)',
    overnightShipping: 'Übernachtversand',
    germany: 'Deutschland',
    austria: 'Österreich',
    switzerland: 'Schweiz',
    japan: 'Japan',
    shippingAddressLabel: 'Lieferadresse',
    changeDeliveryAddress: 'Lieferadresse ändern',
    selectDeliveryAddress: 'Lieferadresse auswählen',
    // Shipping Cost Details
    freeShipping: 'Versandkostenfrei',
    shippingError: 'Fehler',
    shippingZone: 'Versandzone',
    remainingForFreeShipping: 'Noch {amount} für versandkostenfreie Lieferung',
    moreForFreeShipping: 'für versandkostenfreie Lieferung',
    freeShippingProgress: 'Versandkostenfrei ab',
    andAboveFreeShipping: 'versandkostenfrei',
    freeShippingAchieved: 'Versandkostenfrei',
    threshold: 'ab',
    nextShippingTier: 'Nächste Versandkosten-Stufe',
    moreForDiscount: 'weitere',
    shippingSavings: 'Ersparnis bei den Versandkosten',
    orderAmountThreshold: 'Bestellwert ab',
    specialRegionNotice: 'Sonderversandzone wird angewendet',
    defaultShippingApplied: 'Standard-Versandkosten werden angewendet',
    requestedQuantity: 'Angeforderte Menge',
    availableQuantity: 'Verfügbare Menge',
    orderSubmitError: 'Bestellungsfehler',
    orderSubmitErrorDesc: 'Bestellung konnte nicht übermittelt werden',
    upload: {
      title: 'Excel/CSV Bestellung importieren',
      description: 'Laden Sie eine Excel- oder CSV-Datei mit Ihren Bestelldaten hoch',
      dragDropOrClick: 'Datei hierher ziehen oder klicken zum Auswählen',
      dropHere: 'Datei hier ablegen',
      supportedFormats: 'Unterstützte Formate: Excel (.xlsx, .xls) und CSV (.csv)',
      maxSize: 'Maximale Dateigröße: {size} MB',
      processFile: 'Datei verarbeiten',
      processing: 'Datei wird verarbeitet...',
      ready: 'Datei bereit zur Vorschau',
      readyDescription: 'Ihre Datei wurde erfolgreich verarbeitet und ist bereit zur Überprüfung.',
      preview: 'Vorschau anzeigen',
      errors: {
        fileTooLarge: 'Die Datei ist zu groß. Maximale Größe: {size} MB',
        invalidFileType: 'Ungültiger Dateityp. Bitte laden Sie eine Excel- oder CSV-Datei hoch',
        uploadFailed: 'Fehler beim Hochladen der Datei',
      },
    },
    // Loading messages
    loadingPage: 'Seite wird geladen...',
    loadingStock: 'Lagerbestände werden geprüft...',
    loadingAccount: 'Kontoinformationen werden geladen...',
    loadingError: 'Ein Fehler ist aufgetreten...',
    loadingData: 'Daten werden geladen',
    // Toast messages
    addressRetrievedTitle: 'Adressinformationen abgerufen',
    addressSetAsDelivery: ' als Lieferadresse festgelegt.',
    contactFoundDesc: ' wurde erkannt.'
  },
  orderHistory: {
    title: 'Bestellhistorie',
    searchPlaceholder: 'Nach Bestellnummer oder SKU suchen...',
    noOrders: 'Keine Bestellungen vorhanden',
    noOrdersFound: 'Keine passenden Bestellungen gefunden',
    startShopping: 'Produkte ansehen',
    orderItems: 'Bestellte Artikel',
    viewDetails: 'Details',
    reorder: 'Erneut bestellen',
    orderDate: 'Bestelldatum',
    orderStatus: 'Status',
    orderTotal: 'Gesamtbetrag',
    // Status translations
    statusPending: 'Zahlung ausstehend',
    statusProcessing: 'In Bearbeitung',
    statusConfirmed: 'Bestätigt',
    statusShipped: 'Versandt',
    statusDelivered: 'Geliefert',
    statusCancelled: 'Storniert',
    statusReturned: 'Zurückgegeben',
    statusRefunded: 'Erstattet',
    statusWarranty: 'Garantie',
    statusExchanged: 'Ausgetauscht',
    statusRepair: 'Reparatur',
    statusUnknown: 'Unbekannt',
    statusIncomplete: 'Unvollständig',
    statusWaitingPayment: 'Wartet auf Zahlung',
    statusInPreparation: 'In Vorbereitung',
    statusClearedShipping: 'Versandbereit',
    statusBeingShipped: 'Wird versandt',
    statusOutgoingBooked: 'Ausgang gebucht',
    statusReturn: 'Rückgabe',
    // Additional UI elements
    itemCount: 'Artikel',
    itemCountSingular: 'Artikel',
    refreshButton: 'Aktualisieren',
    errorFetchingOrders: 'Fehler beim Laden der Bestellhistorie',
    // Payment status features
    paymentStatus: 'Zahlungsstatus',
    markAsPaid: 'Als bezahlt markieren',
    unmarkAsPaid: 'Zahlungsmarkierung entfernen',
    paidOn: 'Bezahlt am',
    paymentMarked: 'Bezahlt',
    notPaid: 'Nicht bezahlt',
    paymentMarkedSuccess: 'Erfolgreich als bezahlt markiert',
    paymentUnmarkedSuccess: 'Zahlungsmarkierung entfernt',
    paymentUpdateError: 'Fehler beim Aktualisieren des Zahlungsstatus',
    // Payment date dialog
    paymentDateTitle: 'Zahlungsinformationen eingeben',
    paymentDateDescription: 'Zahlungsinformationen für Bestellung {orderNumber} eingeben',
    paymentDateLabel: 'Zahlungsdatum',
    selectDate: 'Datum auswählen',
    paymentDateHelp: 'Wählen Sie das Datum der Banküberweisung',
    paymentMethodLabel: 'Zahlungsmethode',
    bankTransfer: 'Banküberweisung',
    invoice: 'Rechnung',
    otherPayment: 'Sonstige',
    paymentReferenceLabel: 'Überweisungsname / Referenznummer',
    paymentReferencePlaceholder: 'z.B. Max Mustermann, Überweisung #12345',
    paymentReferenceHelp: 'Geben Sie Informationen an, die beim Abgleich mit Kontoauszügen helfen',
    notesLabel: 'Notizen',
    notesPlaceholder: 'Geben Sie zusätzliche Zahlungsinformationen ein',
    // Filter options
    filterByPaymentStatus: 'Nach Zahlungsstatus filtern',
    allOrders: 'Alle Bestellungen',
    paidOrders: 'Bezahlt',
    unpaidOrders: 'Unbezahlt',
    // Sorting options
    sortBy: 'Sortieren nach',
    sortByDate: 'Bestelldatum',
    sortByPaymentDate: 'Zahlungsdatum',
    sortByAmount: 'Betrag',
    sortByStatus: 'Status',
  },
  orderDetails: {
    title: 'Bestelldetails',
    notFound: 'Bestellung nicht gefunden',
    backToHistory: 'Zur Bestellhistorie',
    orderDate: 'Bestelldatum',
    orderItems: 'Bestellte Artikel',
    deliveryStatus: 'Lieferstatus',
    estimatedDelivery: 'Voraussichtliche Lieferung',
    deliveredOn: 'Geliefert am',
    downloadInvoice: 'Rechnung herunterladen',
    statusDelivered: 'Geliefert',
    statusShipped: 'Versandt',
    statusConfirmed: 'Bestätigt',
    statusCancelled: 'Storniert',
    errorFetchingDetails: 'Fehler beim Laden der Bestelldetails',
  },
  company: {
    name: 'Business Partner',
    tagline: 'Business Partner System',
    copyright: '© 2025 Business Partner System. Alle Rechte vorbehalten.',
  },
  footer: {
    phone: 'Telefon',
    email: 'E-Mail',
    countries: {
      DE: 'Deutschland',
      AT: 'Österreich',
      CH: 'Schweiz',
      FR: 'Frankreich',
      IT: 'Italien',
      ES: 'Spanien',
      NL: 'Niederlande',
      BE: 'Belgien',
      PL: 'Polen',
      SE: 'Schweden',
      NO: 'Norwegen',
      FI: 'Finnland',
      DK: 'Dänemark',
      LT: 'Litauen',
      LV: 'Lettland',
      EE: 'Estland',
    },
  },
  cart: {
    newCart: 'Neuer Warenkorb',
    currentCart: 'Aktueller Warenkorb',
    modified: 'geändert',
    lastSaved: 'Zuletzt gespeichert',
    unsavedChanges: 'ungespeicherte Änderungen',
    saveCart: 'Warenkorb speichern',
    loadCart: 'Warenkorb laden',
    deleteCart: 'Warenkorb löschen',
    startNewCart: 'Neuen Warenkorb starten',
    savedCarts: 'Gespeicherte Warenkörbe',
    cartSaved: 'Warenkorb gespeichert',
    cartDeleted: 'Warenkorb gelöscht',
    confirmDeleteCart: 'Warenkorb löschen?\n\nDieser Vorgang kann nicht rückgängig gemacht werden.',
    confirmSwitchCart: 'Der aktuelle Warenkorb hat ungespeicherte Änderungen.\n\nEinen anderen Warenkorb zu laden führt zum Verlust der aktuellen Änderungen.\n\nFortfahren?',
    confirmSwitchCartTitle: 'Warenkorb wechseln',
    confirmNewCart: 'Der aktuelle Warenkorb hat ungespeicherte Änderungen.\n\nEinen neuen Warenkorb zu starten führt zum Verlust der aktuellen Änderungen.\n\nFortfahren?',
    confirmNewCartTitle: 'Neuen Warenkorb starten',
    confirmClearCart: 'Warenkorb leeren?\n\n{count} Artikel werden entfernt.\n\nDieser Vorgang kann nicht rückgängig gemacht werden.',
    confirmClearCartTitle: 'Warenkorb leeren',
    autoSaved: 'Automatisch gespeichert',
    itemsWillBeRemoved: 'Artikel werden entfernt',
    changesWillBeLost: 'Änderungen gehen verloren',
    continueQuestion: 'Fortfahren?',
    cartStatus: 'Warenkorb-Status',
    cartName: 'Warenkorb-Name',
    cartNamePlaceholder: 'z.B.: Monatsende-Bestellung',
    cartNameRequired: 'Bitte geben Sie einen Warenkorb-Namen ein',
    saveCartDescription: 'Geben Sie dem aktuellen Warenkorb einen Namen und speichern Sie ihn. Sie können ihn später laden.',
    cancelCart: 'Warenkorb abbrechen',
    proceedToCheckout: 'Zur Kasse gehen',
    emptyCart: 'Warenkorb ist leer',
    erpDown: 'Das Bestellsystem ist ausgefallen. Bitte versuchen Sie es später erneut.',
    erpDegraded: 'Das System ist derzeit instabil. Bestellungen können fehlschlagen.',
    erpDownSaveHint: 'Bitte speichern Sie Ihren Warenkorb und bestellen Sie später.',
    erpSaveCart: 'Warenkorb speichern',
  },
  nav: {
    dashboard: 'Dashboard',
    products: 'Produkte',
    orderHistory: 'Bestellhistorie',
    account: 'Kontoinformationen',
    bulkImport: 'Massenimport',
  },
  bulkImport: {
    instructions: 'So importieren Sie Bestellungen',
    step1: 'Laden Sie die Bestellvorlage herunter',
    step2: 'Füllen Sie Ihre Bestelldaten mit SKU und Menge aus',
    step3: 'Speichern Sie als Excel (.xlsx) oder CSV-Datei',
    step4: 'Laden Sie die Datei über das untenstehende Formular hoch',
    step5: 'Überprüfen und bestätigen Sie Ihre Bestellung',
    downloadTemplate: 'Vorlage herunterladen',
    downloadExcelTemplate: 'Excel-Vorlage herunterladen',
    downloadCsvTemplate: 'CSV-Vorlage herunterladen',
    formatGuide: 'Dateiformat-Leitfaden',
    requiredColumns: 'Erforderliche Spalten',
    skuDescription: 'Produkt-SKU-Code',
    quantityDescription: 'Bestellmenge (positive Ganzzahl)',
    optionalColumns: 'Optionale Spalten',
    notesDescription: 'Interne Notizen (z.B. Bestellnummer, Referenz) - nur für Ihre Unterlagen',
    formatNote: 'Die erste Zeile sollte Spaltenüberschriften enthalten. Die Daten beginnen in der zweiten Zeile.',
    parseSuccess: 'Erfolgreich {count} Artikel aus der Datei gelesen',
    parseError: 'Fehler beim Parsen der Datei',
    validationError: 'Validierungsfehler',
    validationErrorGuidance: 'Bitte klicken Sie auf die Schaltfläche „{showPreviewButton}“, um die Details zu überprüfen.',
    warnings: 'Warnungen',
    itemsParsed: 'Erfolgreich {count} Artikel gelesen:',
    andMore: '...und {count} weitere Artikel',
    proceedToCart: 'Zum Warenkorb',
    // Additional validation and UI
    validationSummary: 'Validierungszusammenfassung',
    duplicateSKUs: 'Doppelte SKUs gefunden',
    skuFormat: 'SKU darf nur Buchstaben, Zahlen und Bindestriche enthalten',
    quantityRange: 'Menge muss zwischen 1 und 999999 liegen',
    maxRows: 'Maximale Zeilenzahl',
    rowsSkipped: '{count} Zeilen übersprungen',
    previewTitle: 'Bestellvorschau',
    previewDescription: 'Bitte überprüfen und bearbeiten Sie Ihre Bestelldaten vor der Verarbeitung',
    fileEmpty: 'Die Datei ist leer',
    fileTooManyRows: 'Datei hat zu viele Zeilen ({current}). Maximum: {max}',
    invalidRowFormat: 'Ungültiges Zeilenformat',
    missingColumns: 'Erforderliche Spalten fehlen',
    missingSku: 'SKU fehlt',
    invalidSkuFormat: 'Ungültiges SKU-Format: "{sku}" (muss Muster entsprechen: {pattern})',
    skuTooLong: 'SKU zu lang: "{sku}" (Maximum: 50 Zeichen)',
    invalidQuantity: 'Ungültige Menge: "{quantity}" ist keine Zahl',
    quantityTooLow: 'Menge zu niedrig: {quantity} (Minimum: {min})',
    quantityTooHigh: 'Menge zu hoch: {quantity} (Maximum: {max})',
    notesRequired: 'Notizfeld ist erforderlich',
    noValidData: 'Keine gültigen Daten gefunden. Bitte überprüfen Sie das Dateiformat.',
    row: 'Zeile {row}: {errors}',
    rowErrors: '...und {count} weitere Fehler',
    duplicateSkuInRows: 'Doppelte SKU "{sku}" in Zeilen: {rows}',
    quantityExceedsMax: 'Zeile {row}: Menge {quantity} überschreitet Maximum ({max})',
    quantityBelowMin: 'Zeile {row}: Menge {quantity} unterschreitet Minimum ({min})',
    unsupportedFileFormat: 'Nicht unterstütztes Dateiformat',
    csvParsingErrors: 'CSV-Parsing-Fehler',
    failedToParseFile: 'Datei konnte nicht geparst werden',
    failedToParseExcel: 'Excel-Datei konnte nicht geparst werden',
    failedToReadFile: 'Datei konnte nicht gelesen werden',
    unknownError: 'Unbekannter Fehler',
    totalRows: 'Zeilen gesamt',
    valid: 'Gültig',
    invalid: 'Ungültig',
    skipped: 'Übersprungen',
    skuValidationError: 'SKU-Validierungsfehler',
    skuValidationFailed: 'SKU-Validierung fehlgeschlagen',
    skuNotFound: 'SKU nicht gefunden',
    skusNotFound: '{count} SKUs wurden nicht gefunden',
    itemsHaveInsufficientStock: '{count} Artikel haben unzureichenden Lagerbestand',
    validatingSKUs: 'Artikel werden geprüft...',
    actions: 'Aktionen',
    notes: 'Notizen',
    all: 'Alle',
    hasErrors: 'Hat Fehler',
    selected: 'Ausgewählt',
    errors: 'Fehler',
    page: 'Seite {current} / {total}',
    previous: 'Zurück',
    next: 'Weiter',
    noResults: 'Keine Ergebnisse',
    noValidItems: 'Keine gültigen Artikel',
    allItemsHaveErrors: 'Alle Artikel haben Fehler',
    dataLoadingError: 'Fehler beim Laden der Daten',
    failedToLoadProductData: 'Produktdaten konnten nicht geladen werden',
    itemsAddedToCart: '{count} Artikel wurden zum Warenkorb hinzugefügt',
    itemsAddedMessage: '{count} Artikel zum Warenkorb hinzugefügt',
    someSkusNotFound: '{count} SKUs wurden nicht gefunden.',
    noItemsAdded: 'Keine Artikel hinzugefügt',
    couldNotFindProducts: 'Produkte konnten nicht gefunden werden',
    errorAddingToCart: 'Fehler beim Hinzufügen zum Warenkorb',
    failedToAddToCart: 'Hinzufügen zum Warenkorb fehlgeschlagen',
    addingToCart: 'Zum Warenkorb hinzufügen...',
    fileSelected: '{name} zur Verarbeitung ausgewählt',
    fileSize: '{size} Bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    templateDownload: 'Vorlage herunterladen',
    templateWillBeImplemented: 'Vorlagen-Download wird bald implementiert',
    validationFailed: 'Validierung fehlgeschlagen',
    // Template download
    templateDownloaded: 'Vorlage erfolgreich heruntergeladen',
    templateDownloadError: 'Fehler beim Herunterladen der Vorlage',
    // Template content
    sheetName: 'Sammelbestellung',
    instructionsSheetName: 'Anleitung',
    columnDescriptions: 'Spaltenbeschreibungen:',
    columnHeader: 'Spalte',
    columnRequired: 'Erforderlich',
    columnOptional: 'Optional',
    columnDescription: 'Beschreibung',
    templateNotes: 'Hinweise:',
    templateNote1: 'Die erste Zeile muss die Spaltenüberschriften genau wie angezeigt enthalten',
    templateNote2: 'Daten beginnen ab Zeile 2',
    templateNote3: 'SKU muss mit vorhandenen Produktcodes im System übereinstimmen',
    templateNote4: 'Menge muss eine positive Ganzzahl zwischen 1 und 9999 sein',
    templateNote5: 'Maximal 1000 Zeilen pro Datei erlaubt',
    templateNote6: 'Als .xlsx oder .csv Format speichern',
    stockAvailabilityWarning: 'Die tatsächliche Lagerverfügbarkeit wird auf der nächsten Checkout-Seite überprüft.',
    outOfStock: 'Nicht auf Lager',
    insufficientStock: 'Unzureichender Lagerbestand: {available} verfügbar, {requested} angefordert',
    unvalidatedChanges: 'Sie haben nicht validierte Änderungen. Bitte validieren Sie erneut, bevor Sie zum Warenkorb hinzufügen.',
    revalidate: 'Erneut validieren',
    validating: 'Validierung...',
    validationSuccess: 'Alle Artikel sind gültig',
    validationComplete: 'Validierung abgeschlossen',
    validationResultSummary: '{errors} Fehler, {warnings} Warnungen gefunden',
  },
  settings: {
    selectLanguage: 'Sprache auswählen',
    languagePreferenceSaved: 'Ihre Spracheinstellung wird für zukünftige Besuche in Ihrem Konto gespeichert.',
  },
  reorder: {
    allItemsAdded: '{count} Artikel zum Warenkorb hinzugefügt',
    partialSuccess: '{added} Artikel hinzugefügt. {failed} Artikel konnten nicht hinzugefügt werden',
    allItemsFailed: 'Artikel konnten nicht zum Warenkorb hinzugefügt werden',
    error: 'Bei der Nachbestellung ist ein Fehler aufgetreten',
    itemDiscontinued: '{name} ({color}/{size}) wurde eingestellt',
    itemOutOfStock: '{name} ({color}/{size}) ist nicht vorrätig',
    partialStock: '{name} ({color}/{size}) nur {available} verfügbar',
    confirmReorder: 'Nachbestellung bestätigen',
    confirmReorderMessage: 'Artikel aus dieser Bestellung zum Warenkorb hinzufügen?',
    addingToCart: 'Zum Warenkorb hinzufügen...',
    checkingStock: 'Lagerbestand prüfen...',
    checkoutTitle: 'Artikel zum Warenkorb hinzugefügt',
    checkoutDescription: '{count} Artikel wurden zum Warenkorb hinzugefügt. Möchten Sie zur Kasse gehen?',
  },
  orderExport: {
    export: 'Bestellung exportieren',
    exportOrder: 'Bestelldaten exportieren',
    exportAsCSV: 'Als CSV exportieren',
    exportAsExcel: 'Als Excel exportieren',
    exportForReorder: 'Für Massenimport exportieren',
    detailed: 'Vollständige Details',
    simpleFormat: 'Import-Format',
  },
};